// extracted by mini-css-extract-plugin
export var arrows = "_5y-5";
export var decrementer = "_5y-9";
export var disabled = "_5y-3";
export var error = "_5y-1";
export var hiddenText = "_5y-a";
export var incrementer = "_5y-8";
export var input = "_5y-7";
export var inputWrapper = "_5y-0";
export var leadingIcon = "_5y-b";
export var readonly = "_5y-2";
export var regular = "_5y-6";
export var small = "_5y-4";